import { createSelector, createFeatureSelector } from '@ngrx/store';

import * as clientActions from '../actions/client.actions';
import { IClient, IEvent, IClientModules } from "../../models/client.model";
import { MainModule } from "./main.reducer";

export type Actions = clientActions.All;
type MODULE_NAMES = 'event' | 'note' | 'stand' | 'interest' | 'survey' | 'streaming' | 'reserves' | 'catalog' | 'gamification' | 'notification' | 'news' | 'sponsor' | 'staff' | 'networking' | 'questions' | 'resource' | 'map' | 'commercial_samples' | 'timeline' | 'opinometer' | 'voting';

export interface ClientState {
  client: IClient,
  events?: IEvent[],
  loading?: boolean,
  loaded?: boolean
}

export const initialValue: ClientState = {
  client: {
    categories: null,
    defaultLanguage: null,
    id: null,
    name: null,
    nit: null,
    state: null,
    payment_additional_methods: null,
    style_first_color: null,
    style_second_color: null,
    style_third_color: null,
    style_fourth_color: null,
    style_image_header: null,
    style_image_page: null,
    style_contrast: null,
    modules: null,
    with_payments: null,
    currency: null,
    url_webapp: null,
    client_shop: null,
    max_coupons_users: null,
    hide_side_menu: false,
    event_segment: false,
  },
  events: null,
  loading: false,
  loaded: false
}

export function clientReducer(state: ClientState = initialValue, action: Actions) {
  switch (action.type) {
    case clientActions.GET_CLIENT:
      return { ...state, loading: true };
    case clientActions.GET_CLIENT_SUCCESS:
      return { ...state, client: action.payload, loaded: true, loading: false };
    case clientActions.GET_CLIENT_FAILED:
      return initialValue;
    default:
      return state;
  }
}

export const getMainModule = createFeatureSelector<MainModule>('mainModule');
export const getClientState = createSelector(getMainModule, (state: MainModule) => state.clientState);
export const getClient = createSelector(getClientState, (state: ClientState) => state.client);
export const getEvents = createSelector(getClientState, (state: ClientState) => state.events);
export const getClientId = createSelector(getClientState, (state: ClientState) => {
  if (state.client) {
    return state.client.id;
  }
});
export const getClientConfig = createSelector(getClientState, (state: ClientState) => {
  if (state.client) {
    return {
      "id": state.client.id,
      "style_contrast": state.client.style_contrast,
      "style_first_color": state.client.style_first_color,
      "style_fourth_color": state.client.style_fourth_color,
      "style_image_header": state.client.style_image_header,
      "style_image_page": state.client.style_image_page,
      "style_second_color": state.client.style_second_color,
      "style_third_color": state.client.style_third_color,
      "with_payments": state.client.with_payments,
      "currency": state.client.currency,
      "url_webapp": state.client.url_webapp,
      "client_shop": state.client.client_shop,
      "defaultLanguage": state.client.defaultLanguage,
      "state": state.client.state,
      "payment_additional_methods": state.client.payment_additional_methods,
      "hide_side_menu": state.client.hide_side_menu,
      "max_coupons_users": state.client.max_coupons_users,
      "event_segment": state.client.event_segment
    }
  }
});
export const getCategories = createSelector(getClientState, (state: ClientState) => state.client.categories);
export const getClientModules = createSelector(getClientState, (state: ClientState) => state.client.modules);
export const getClientSingleModule = (moduleName: MODULE_NAMES) => {
  return createSelector(getClientModules, (modules: IClientModules) => {
    if (modules) return modules[moduleName];
  });
};



// WEBPACK FOOTER //
// ./src/ngrx/reducers/client.reducer.ts